import {
  CompositeFilterDescriptor,
  FilterDescriptor,
} from "@progress/kendo-data-query/dist/npm/filtering/filter-descriptor.interface";

export function buildFilter(filterFields: string[], inputValue: string) {
  const buildFilters: FilterDescriptor[] = [];

  filterFields.forEach((field) => {
    const filter = {
      field,
      operator: "contains",
      value: inputValue,
    };
    buildFilters.push(filter);
  });

  const filter: CompositeFilterDescriptor = {
    logic: "or",
    filters: buildFilters,
  };
  return filter;
}
